export default __webpack_public_path__ + "fonts/Roboto-500-latin-ext20.woff2";